/**
 * Generated bundle index. Do not edit.
 */

export {LCFormsModule} from './public_api';

export {LCElementComponent as ɵc} from './src/app/components/lc-element.component';
export {LCFormComponent as ɵa} from './src/app/components/lc-forms.component';
export {LCFormService as ɵb} from './src/app/components/lc-forms.service';